import { __assign, __extends } from "tslib";
import React from 'react';
import BaseViewer from './Base';
import omit from 'lodash/omit';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/deviantId.scss';
var DeviantIdViewer = /** @class */ (function (_super) {
    __extends(DeviantIdViewer, _super);
    function DeviantIdViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.theme = mergeTheme(baseTheme, _this.props.theme);
        return _this;
    }
    DeviantIdViewer.prototype.render = function () {
        var restProps = omit(this.props, ['theme']);
        return (React.createElement("div", { className: 'da-editor-deviantid' },
            React.createElement(BaseViewer, __assign({ theme: this.theme }, restProps, { fixedParagraph: false }))));
    };
    return DeviantIdViewer;
}(React.Component));
export default DeviantIdViewer;
//# sourceMappingURL=DeviantId.js.map